import React, { useState, useEffect } from "react";
import ShowImage from "../ShowImage";
import { isAuthenticated } from "../../auth";
import Swal from "sweetalert2";
import { Redirect } from "react-router-dom";
import BackBtn from "../../btncomponent/BackBtn";

const EditRoom = (props) => {
  const [values, setValues] = useState({
    name: "",
    description: "",
    price: "",
    distance: "",
    kitchen: "",
    bathroom: "",
    bedroom: "",
    map: "",
    photo: "",
    loading: false,
    error: "",
    formData: "",
    redirect: false,
  });

  const {
    name,
    description,
    price,
    distance,
    kitchen,
    bathroom,
    bedroom,
    map,
    loading,
    error,
    formData,
    redirect,
  } = values;

  const { user, token } = isAuthenticated();

  useEffect(() => {
    const roomId = props.match.params.SingleRoom;
    console.log(roomId);
    setValues({ loading: true });
    const fetchdata = () => {
      fetch(`${process.env.REACT_APP_API_URL}/home/${roomId}`, {
        method: "GET",
      })
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          if (data.error) {
            console.log(data.error);
          } else {
            setValues({
              name: data.name,
              description: data.description,
              price: data.price,
              distance: data.distance,
              kitchen: data.kitchen,
              bathroom: data.kitchen,
              bedroom: data.bathroom,
              map: data.map,
              formData: new FormData(),
            });
          }
        });
    };
    fetchdata();
  }, []);

  const handleChange = (name) => (event) => {
    const value = name === "photo" ? event.target.files[0] : event.target.value;
    formData.set(name, value);
    setValues({ ...values, [name]: value });
  };

  const clickSubmit = (e) => {
    setValues({ ...values, error: "", loading: true });
    const roomId = props.match.params.SingleRoom;
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}/home/${roomId}/${user._id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        console.log(err);
      })
      .then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error });
        } else {
          Swal.fire({
            title: " Room Updated",
            icon: "success",
          });

          setValues({
            ...values,
            name: "",
            description: "",
            photo: "",
            price: "",
            distance: "",
            kitchen: "",
            category: "",
            bathroom: "",
            bedroom: "",
            map: "",
            loading: false,
            redirect: true,
          });
        }
      });
  };

  const showError = () => (
    <div
      className="alert alert-danger"
      style={{ display: error ? "" : "none" }}
    >
      {error}
    </div>
  );

  const showLoading = () =>
    loading && (
      <div className="alert alert-success">
        <h2>Loading...</h2>
      </div>
    );

  const redirectTo = () => {
    if (redirect) {
      if (!error) {
        return <Redirect to="/" />;
      }
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-muted">Edit Room</h2>
      <BackBtn location={"/"} />
      {showLoading()}
      {showError()}
      {redirectTo()}
      <form className="mb-3 mt-3" onSubmit={clickSubmit}>
        <label className="text-muted">Add Photo</label>
        <div className="form-group">
          <div className="row">
            <div className="col-sm-3">
              <label className="btn btn-secondary">
                <input
                  onChange={handleChange("photo")}
                  id="customFile"
                  type="file"
                  name="photo"
                  accept="image/*"
                  className="mb-2"
                />
              </label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label className="text-muted">Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={handleChange("name")}
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Description</label>
          <textarea
            className="form-control"
            value={description}
            onChange={handleChange("description")}
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Price</label>
          <input
            type="text"
            className="form-control"
            value={price}
            onChange={handleChange("price")}
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Distance</label>
          <input
            type="text"
            className="form-control"
            value={distance}
            onChange={handleChange("distance")}
          />
        </div>

        <div className="form-group">
          <label className="text-muted">Kitchen</label>
          <input
            type="text"
            className="form-control"
            value={kitchen}
            onChange={handleChange("kitchen")}
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Bathroom</label>
          <input
            type="text"
            className="form-control"
            value={bathroom}
            onChange={handleChange("bathroom")}
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Bedroom</label>
          <input
            type="text"
            className="form-control"
            value={bedroom}
            onChange={handleChange("bedroom")}
          />
        </div>
        <div className="form-group">
          <label className="text-muted">Map</label>
          <input
            type="text"
            className="form-control"
            value={map}
            onChange={handleChange("map")}
          />
        </div>

        <button className="btn btn-outline-primary mt-2">Update</button>
      </form>
    </div>
  );
};

export default EditRoom;
